import { elevation, themeBackgrounds, themeColors } from "@dana/MobiusOverrides/styles/colors";
import { ProductCompareCarouselStyles } from "@dana/Overrides/Widgets/ProductCompare/ProductCompareCarousel";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

ProductCompareCarouselStyles.headerContainer = mergeToNew(ProductCompareCarouselStyles.headerContainer, {
    gap: 10,
});

ProductCompareCarouselStyles.headerText = mergeToNew(ProductCompareCarouselStyles.headerText, {
    css: css`
        margin-bottom: 16px;
    `,
});

ProductCompareCarouselStyles.carousel = mergeToNew(ProductCompareCarouselStyles.carousel, {
    prevArrowButton: {
        shape: "rectangle",
        css: css`
            padding: 0;
            min-width: auto;
            min-height: auto;
            z-index: 2;
            justify-content: center;
            background: none;
            border: none;

            ${IconWrapper} {
                svg {
                    path {
                        fill: ${themeColors.secondary.danaDarkBlue};
                    }
                }
            }

            &:not(:disabled) {
                &:hover {
                    background: transparent;
                    border: none;

                    ${IconWrapper} {
                        svg {
                            path {
                                fill: ${themeColors.secondary.danaBrightBlue};
                            }
                        }
                    }
                }

                &:focus {
                    outline: none;
                }

                &:focus-visible {
                    background: transparent;
                    border: 1px solid ${themeColors.primary.white};
                    box-shadow: ${elevation.focus};
                    outline: none;

                    ${IconWrapper} {
                        svg {
                            path {
                                fill: ${themeColors.secondary.danaBrightBlue};
                            }
                        }
                    }
                }
            }

            &:disabled {
                background: none;
                border: none;
                ${IconWrapper} {
                    svg {
                        path {
                            fill: ${themeBackgrounds.darkGray};
                        }
                    }
                }
            }
        `,
    },
    nextArrowButton: {
        shape: "rectangle",
        css: css`
            padding: 0;
            min-width: auto;
            min-height: auto;
            z-index: 2;
            justify-content: center;
            background: none;
            border: none;

            ${IconWrapper} {
                svg {
                    path {
                        fill: ${themeColors.secondary.danaDarkBlue};
                    }
                }
            }

            &:not(:disabled) {
                &:hover {
                    background: transparent;
                    border: none;

                    ${IconWrapper} {
                        svg {
                            path {
                                fill: ${themeColors.secondary.danaBrightBlue};
                            }
                        }
                    }
                }

                &:focus {
                    outline: none;
                }

                &:focus-visible {
                    background: transparent;
                    border: 1px solid ${themeColors.primary.white};
                    box-shadow: ${elevation.focus};
                    outline: none;

                    ${IconWrapper} {
                        svg {
                            path {
                                fill: ${themeColors.secondary.danaBrightBlue};
                            }
                        }
                    }
                }
            }

            &:disabled {
                background: none;
                border: none;
                ${IconWrapper} {
                    svg {
                        path {
                            fill: ${themeBackgrounds.darkGray};
                        }
                    }
                }
            }
        `,
    },
    carouselSlide: {
        css: css`
            padding: 0 4px;
        `,
    },
    carouselSlideInner: {
        css: css`
            height: 100%;
            width: 100%;
            padding: 16px;
            border: 1px solid #dedede;
            background: #ffffff;
        `,
    },
    attributeLabelGridItem: {
        css: css`
            &:nth-child(even) {
                background-color: transparent;
            }
        `,
    },
    attributeValueGridItem: {
        css: css`
            &:nth-child(even) {
                background-color: transparent;
            }
        `,
    },
    carouselContentEmptyCellGridItem: {
        width: [4, 4, 3, 3, 3],
    },
    attributeLabelsCellGridItem: {
        width: [4, 4, 3, 3, 3],
    },
    carouselCellGridItem: {
        width: [8, 8, 9, 9, 9],
    },
    attributeValuesCellGridItem: {
        width: [8, 8, 9, 9, 9],
    },
});

ProductCompareCarouselStyles.removeProductFromCompareClickable = mergeToNew(
    ProductCompareCarouselStyles.removeProductFromCompareClickable,
    {
        css: css`
            right: 8px;
            top: 8px;
        `,
    },
);
